import React, { useState, useEffect } from 'react';
import '../HomePage.css';

const descriptionWords = [
  "Personal",
  "Virtual",
  "Automated",
  "Bespoke",
  "Intelligent",
  "Strategic",
  "Insightful",
  "Innovative",
  "Proactive",
  "Dynamic",
  "Comprehensive",
]

const highlightColors = [
  "#00ffe7", // neon cyan
  "#ffea00", // neon yellow
  "#ff00c8", // neon magenta
  "#39ff14", // neon green
  "#ff073a", // neon red
  "#00f0ff", // electric blue
  "#ff9100", // neon orange
  "#f500ff", // neon purple
  "#00ffb3", // neon aqua
  "#ff3c00", // neon orange-red
  "#fff700", // neon lemon
];

function HomePageHeader() {
    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const [animKey, setAnimKey] = useState(0);

    // useEffect to change the highlighted word every 1.5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => {
                const nextIndex = (prevIndex + 1) % descriptionWords.length;
                setAnimKey(nextIndex); // force re-animation
                return nextIndex;
            });
        }, 2500); // Change word every 1.5 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <div className="home-intro">
            <h1>
                <div>
                    Welcome to your own {" "}
                </div>
                <div>
                    <span
                        className="highlight"
                        key={animKey}
                        style={{ color: highlightColors[currentWordIndex] }}
                    >
                        {descriptionWords[currentWordIndex]}
                    </span> CFO
                </div>
            </h1>
            <div className="home-intro-subtitle-container">
                <span className="home-intro-subtitle">
                    Your personal financial strategist, guiding you to success. Educates, guides and supports defining, visualizing, and achieving your business goals. Take control of your financial future today.
                </span>
            </div>
            <div className="home-intro-cta-button">
                <div className="home-intro-cta-text">
                    <span>Learn More</span>
                </div>
            </div>
            <div className="icon-scroll-spacer"> 
                <div className="icon-container">
                    <div className="icon-scroll"></div>
                </div>
            </div>
        </div>
    );
}

export default HomePageHeader;